// extracted by mini-css-extract-plugin
module.exports = {"newJobListHeader":"newJobListHeader","newJobList__pageTitle":"newJobList__pageTitle","jobCountInfo":"jobCountInfo","jobCountNumber":"jobCountNumber"};